module.exports = __webpack_public_path__ + "static/WheatsvilleCoOp_pin_hover-393d17ef5c1bdb99fa2b441248d902d7.png";